// Centralized data-testid keys.
export const TID = {
  // Marketing
  landingHero: "landing-hero",
  landingCta: "landing-cta-primary",
  landingDemoBtn: "landing-demo-btn",
  landingLogin: "landing-login-btn",
  pricingCard: (id) => `pricing-card-${id}`,
  pricingCta: (id) => `pricing-cta-${id}`,

  // Auth
  loginEmail: "login-email",
  loginPassword: "login-password",
  loginSubmit: "login-submit",
  loginError: "login-error",
  registerEmail: "register-email",
  registerPassword: "register-password",
  registerFirstName: "register-first-name",
  registerLastName: "register-last-name",
  registerOrgName: "register-org-name",
  registerSubmit: "register-submit",
  forgotEmail: "forgot-email",
  forgotSubmit: "forgot-submit",
  resetPassword: "reset-password",
  resetSubmit: "reset-submit",

  // App layout
  sidebar: "app-sidebar",
  sidebarLink: (mod) => `sidebar-link-${mod}`,
  topbarOrgSwitcher: "topbar-org-switcher",
  topbarCompanySwitcher: "topbar-company-switcher",
  topbarNotifications: "topbar-notifications",
  topbarProfile: "topbar-profile",
  logoutBtn: "user-menu-logout",

  // Dashboard
  dashboard: "dashboard",
  kpi: (name) => `kpi-${name}`,

  // Companies / Buildings
  companyAddBtn: "company-add-btn",
  companyRow: (id) => `company-row-${id}`,
  buildingAddBtn: "building-add-btn",

  // Documents
  documentsUploadBtn: "documents-upload-btn",
  documentsList: "documents-list",

  // Settings
  settingsInviteEmail: "settings-invite-email",
  settingsInviteRole: "settings-invite-role",
  settingsInviteSubmit: "settings-invite-submit",

  // Demo
  demoResetBtn: "demo-reset-btn",
};

export const MODULES = [
  { key: "assistant", label: "Mon Assistant", path: "/app/assistant", available: true, icon: "Sparkles" },
  { key: "command-center", label: "Poste de commandement", path: "/app/command-center", available: true, icon: "Compass" },
  { key: "companies", label: "Groupe et sociétés", path: "/app/companies", available: true, icon: "Building" },
  { key: "patrimoine", label: "Patrimoine", path: "/app/patrimoine", available: true, icon: "Landmark" },
  { key: "buildings", label: "Immeubles et biens", path: "/app/buildings", available: true, icon: "Home" },
  { key: "locations", label: "Locations", path: "/app/locations", available: true, icon: "KeyRound" },
  { key: "inventories", label: "États des lieux", path: "/app/inventories", available: true, icon: "ClipboardCheck" },
  { key: "credits", label: "Crédits", path: "/app/credits", available: true, icon: "CreditCard" },
  { key: "performance", label: "Performance", path: "/app/performance", available: true, icon: "TrendingUp" },
  { key: "compliance", label: "Conformité", path: "/app/compliance", available: true, icon: "ShieldCheck" },
  { key: "finances", label: "Finances", path: "/app/finances", available: false, icon: "Coins" },
  { key: "documents", label: "Documents", path: "/app/documents", available: true, icon: "FileText" },
  { key: "analysis", label: "Analyse IA", path: "/app/analysis", available: true, icon: "Sparkles" },
  { key: "accounting", label: "Comptabilité", path: "/app/accounting", available: true, icon: "Calculator" },
  { key: "deadlines", label: "Échéances", path: "/app/deadlines", available: true, icon: "CalendarClock" },
  { key: "mdb", label: "Marchand de biens", path: "/app/mdb", available: true, icon: "Store" },
  { key: "rapports", label: "Rapports", path: "/app/rapports", available: false, icon: "FileBarChart" },
  { key: "settings", label: "Paramètres", path: "/app/settings", available: true, icon: "Settings" },
];

export const ROLES = [
  { value: "owner", label: "Propriétaire du compte" },
  { value: "admin", label: "Administrateur" },
  { value: "manager", label: "Gestionnaire" },
  { value: "collaborator", label: "Collaborateur" },
  { value: "accountant", label: "Comptable" },
  { value: "read_only", label: "Lecture seule" },
  { value: "tenant", label: "Locataire" },
];
